import type { ReactNode } from 'react';

/**
 * PageHeader — header titre + sous-titre partage par toutes les pages du dialer.
 */
interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /** W6: the back-office pages have no layout title, so their header is the page's one <h1> (DESIGN.md §5). */
  as?: 'h1' | 'h2';
}

export default function PageHeader({ title, subtitle, actions = null, as: Heading = 'h2' }: PageHeaderProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 mb-1">
      <div className="min-w-0">
        <Heading className="text-2xl font-semibold text-foreground mb-0.5 truncate">{title}</Heading>
        {subtitle ? (
          <p className="text-sm text-muted-foreground">{subtitle}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>
      ) : null}
    </div>
  );
}
